export enum GroupType {
  GROUP = 1
}
